/**
 * Logger Utility
 * Centralized logging system that respects debug configuration
 */

/* eslint-disable no-console */
import config from '../config';

class Logger {
  constructor() {
    this.debugEnabled =
      config.features.debug || process.env.NODE_ENV === 'development';
  }

  log(...args) {
    if (this.debugEnabled) {
      console.log(...args);
    }
  }

  warn(...args) {
    if (this.debugEnabled) {
      console.warn(...args);
    }
  }

  error(...args) {
    // Errors are always logged, even in production
    console.error(...args);
  }

  info(...args) {
    if (this.debugEnabled) {
      console.info(...args);
    }
  }

  debug(...args) {
    if (this.debugEnabled) {
      console.debug(...args);
    }
  }
}

const logger = new Logger();
export default logger;
